import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const fmt = (s) => {
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return (h ? `${h}:${String(m).padStart(2, "0")}` : String(m)) + ":" + String(sec).padStart(2, "0");
};

export default function CourtTimer({ since, size = "sm", testid }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const iv = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(iv); }, []);
  if (!since) return null;
  const secs = Math.max(0, Math.floor((now - new Date(since).getTime()) / 1000));
  const long = secs >= 40 * 60;
  const cls = size === "lg" ? "text-xl px-2.5 py-1 gap-1.5" : "text-[11px] px-1.5 py-0.5 gap-1";
  return (
    <span data-testid={testid} title="Time since court was assigned"
      className={`inline-flex items-center border font-mono font-black tabular-nums leading-none ${cls} ${long ? "border-amber-400/70 text-amber-300 bg-amber-400/10" : "border-zinc-600 text-zinc-200 bg-black/60"}`}>
      <Timer className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} /> {fmt(secs)}
    </span>
  );
}
